<ng-container *ngIf="formGroup">
    <form [formGroup]="formGroup">
        <ion-item>
            <p class="selection-title">
                {{ getText(question.globalizationConfig, "title") }}
            </p>
            <ion-select
                    [placeholder]="'dashboard.selectOne' | translate"
                    [formControlName]="'field' + question.currentIndex + (isManagerComment ? 'Comment' : '')"
                    [interfaceOptions]="{ cssClass: 'question-type-select' }"
            >
                <ion-select-option
                        *ngFor="let opValue of question.typeConfig.possibleValuesGlobalized['en-US']; let vIndex = index"
                        [value]="opValue">
                    {{ getText(question.typeConfig.possibleValuesGlobalized, vIndex) | uppercase }}
                </ion-select-option>
            </ion-select>
        </ion-item>
    </form>
</ng-container>